<template>
    <div class="home">
		<router-view v-if="$route.name == 'login'" />
		<div v-show="$route.name !== 'login'" class="grid">
			<navigation-view class="home__navigation" :items="pages" @itemClick="navItemClick" />
			<div class="home__top-bar" :style="'grid-template-columns: auto fit-content(200px) 50px 10px;'">
				<div />
				<image-button-view class="home__top-bar__image-button" :label="$store.state.user.name" image="/images/icon-user.png" @click.stop="userButtonClick($event)" />
				<icon-button-view ref="quickCreateButton" class="home__top-bar__icon-button" icon="settings" @click.stop="quickCreateButtonClick($event)" />
			</div>
			<div class="home__content">
				<fade-transition>
					<router-view ref="page" class="home__page" :app="app" v-on="{push, pop, replace, close}" />
				</fade-transition>
				<window-stack ref="windowStack" class="home__content__window-stack" />
			</div>
		</div>
		<popup-controller ref="popupController" />
		<div :class="{
			'mobile-menu': true,
			open: mobile.menu.open
		}">
			<mobile-navigation-view class="navigation" :items="pages" @itemClick="navItemClick" />
		</div>
    </div>
</template>

<script>
	import WindowStack from '../WindowStack';
	import PopupController from '../PopupController';
	import ContextPopupView from '../views/ContextPopupView';
	import IconButtonView from '../views/IconButtonView';
	import FadeTransition from '../../transitions/SlideTransition';
	import Settings from '../windows/SettingsWindow';
	import ProfilePicture from '@/assets/images/profile-picture.png';

	import { bus } from '../../bus';

    export default {
        components: {
			windowStack: WindowStack,
			fadeTransition: FadeTransition,
			popupController: PopupController
		},
		data() {
			return {
				profilePicture: ProfilePicture,
				taskTypes: [],
				direction: 'down',
				dev: true,
				search: '',
				searchTimeout: null,
				mobile: {
					menu: {
						open: false
					}
				}
			};
		},
		computed: {
			_taskTypes() {
				var r = {};

				for (var i = 0; i < this.taskTypes.length; ++i) {
					r[this.taskTypes[i].name] = this.taskTypes[i];
				}

				return r;
			}
		},
		props: ['app', 'pages'],
		methods: {
			navItemClick: function (name) {
				if (name == 'settings') {
					this.$refs.windowStack.push(Settings);
				} else {
					this.$router.push({
						name: name
					});
				}

				this.mobile.menu.open = false;
			},
			push: function () {
				this.$refs.windowStack.push(Settings);
			},
			pop: function () {
				this.$refs.windowStack.pop();
			},
			replace: function () {
				this.$refs.windowStack.replace(IconButtonView);
			},
			close: function () {
				this.$refs.windowStack.close();
			},
			done: function () {
				
			},
			doSearch() {
				if (this.SearchPopupView == '') return;

				var self = this;

				this.axios
					.get('/search/?search=' + encodeURI(this.search))
					.then(function (r) {
						self.$store.state.popupController.popup(this.SearchPopupView, {
							anchor: self.$refs.search.$el,
							align: 'left',
							left: 50,
							results: r.data,
							select: function (/*type, id*/) {
	
							}
						});
					});
			},
			searchKeyUp(/*e*/) {
				var self = this;

				if (this.searchTimeout) clearTimeout(this.searchTimeout);

				self.$store.state.popupController.close();

				this.searchTimeout = setTimeout(function () {
					self.doSearch();
				}, 500);
			},
			userButtonClick(event) {
				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 20,
					actions: [
						{
							label: 'Log ud',
							action: function () {
								console.log('op');
								self.$store.commit('auth', null);
								localStorage.removeItem('auth');
								self.$router.push({
									name: 'login',
									params: {
										lang: 'da'
									},
								});
							}
						}
					]
				});
			},
			async updateDepartment() {
				var self = this;

				return new Promise(function (resolve) {
					self.axios
						.get('/department/')
						.then(function (r) {
							self.$store.commit('department', r.data);
							bus.$emit('update');
							resolve(true);
						}, function () {
							resolve(false);
						});
				});
			},
			async setDepartment(departmentId) {
				var self = this;

				return new Promise(function (resolve) {
					self.axios
						self.axios
					.put('/token/', {
						department_id: departmentId
					})
					.then(async function (r) {
						self.$store.state.auth = r.data;
						await self.updateDepartment();

						resolve(true);
					}, function () {
						resolve(false);
					});
				});
			},
			async departmentButtonClick(event) {
				var self = this;
				var departments = this.$store.state.employee._embedded.departments
				var actions = [];

				if (departments.length == 0) return;

				for (var i = 0; i < departments.length; ++i) {
					actions.push(function () {
						var j = i;

						return {
							label: departments[j].label,
							async action() {
								bus.$emit('clear');
								await self.setDepartment(departments[j].id);
							}
						};
					}());
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					left: 20,
					actions: actions
				});
			},
			quickCreateButtonClick() {
				
			}
		},
		watch: {
			'$route.name': function (val, oldVal) {
				for (var i in this.pages) {
					if (this.pages[i].name == val) {
						this.direction = 'up';
						return;
					}

					if (this.pages[i].name == oldVal) {
						this.direction = 'down';
						return;
					}
				}
			}
		},
		mounted: function () {
			this.$store.state.windowStack = this.$refs.windowStack;
			this.$store.state.popupController = this.$refs.popupController;
	
			this.dev = process.env.NODE_ENV == 'development';
		},
		created() {
			var self = this;

			window.addEventListener('keydown', function(e) {
				// F5
				if (e.keyCode == 116) {
					e.returnValue = false;

					bus.$emit('update');
					return false;
				}
			});

			bus.$on('mobile-menu-toggle', function () {
				self.mobile.menu.open = !self.mobile.menu.open;
			});
		}
    }
</script>

<style lang="scss">
	.home {
		width: 100%;
		height: 100%;

		& > .mobile-menu {
			position: absolute;
			left: -300px;
			top: 0;
			width: 300px;
			height: 100%;
			transition: left 250ms ease-in-out;

			&.open {
				left: 0px;
			}

			& > .navigation {
				height: 100%;
			}
		}

		& > .grid {
			width: 100%;
			height: 100%;
			display: grid;
			grid-template-columns: 70px auto;
			grid-template-rows: 61px auto;
			grid-template-areas:
				"home__navigation home__top-bar"
				"home__navigation home__page";
		}

		&__navigation {
			grid-area: home__navigation;
		}

		&__top-bar {
			position: relative;
			grid-area: home__top-bar;
			background-color: white;
			/*border-bottom: 1px solid #cecece; */

			display: grid;
			grid-template-columns: auto 50px 50px 50px fit-content(200px);
			grid-template-rows: auto;

			&__image-button {
				height: 100%;
			}
		}

		&__content {
			grid-area: home__page;
			position: relative;
			overflow: hidden;
		}

		&__page {
			width: 100%;
			left: 0;
			top: 0;
			bottom: 0;

			position: absolute;
		}
	}

	.navigation {
		&__pos--default {
			margin-top: 20px;
		}

		&__pos--bottom {
			position: absolute;
			left: 0;
			bottom: 20px;
			width: 100%;
		}
	}

	@media only screen and (max-width: 600px) {
		.home {
			& > .grid {
				grid-template-columns: 1fr;
				grid-template-rows: 1fr;

				grid-template-areas: "home__page";
			}

			&__navigation, &__top-bar {
				display: none;
			}
		}
	}
</style>